/**
 * Nút "Nghe mẫu" câu Phát âm — đọc bằng giọng máy của trình duyệt (miễn phí, không gọi
 * server, xem `lib/speech.ts`). Chỉ dùng cho bài tập + QuizBuilder (GV nghe thử);
 * KHÔNG hiện trong bài kiểm tra.
 */
import { useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import { SoundOutlined } from "@ant-design/icons";

import { hasVoiceFor, speak, speechSupported, stopSpeaking } from "@/lib/speech";

const LANGUAGE_LABEL: Record<string, string> = {
  ja: "tiếng Nhật",
  en: "tiếng Anh",
  zh: "tiếng Trung",
  ko: "tiếng Hàn",
};

interface Props {
  text: string;
  language: string;
  label?: string;
  size?: "small" | "middle";
}

export function ListenSampleButton({ text, language, label = "Nghe mẫu", size = "middle" }: Props) {
  const [playing, setPlaying] = useState(false);
  const [voiceOk, setVoiceOk] = useState(true);

  useEffect(() => {
    let alive = true;
    void hasVoiceFor(language).then((ok) => alive && setVoiceOk(ok));
    return () => {
      alive = false;
      stopSpeaking();
    };
  }, [language]);

  if (!speechSupported()) return null;

  const onClick = async () => {
    setPlaying(true);
    await speak(text, language);
    setPlaying(false);
  };

  const btn = (
    <Button
      size={size}
      icon={<SoundOutlined />}
      loading={playing}
      disabled={!text.trim() || !voiceOk}
      onClick={() => void onClick()}
      data-testid="listen-sample"
    >
      {label}
    </Button>
  );
  return voiceOk ? (
    btn
  ) : (
    <Tooltip
      title={`Máy/trình duyệt này chưa có giọng đọc ${LANGUAGE_LABEL[language] ?? language}. Thử Chrome hoặc điện thoại.`}
    >
      <span>{btn}</span>
    </Tooltip>
  );
}
